<template>
  <a-layout class='index animated fadeIn'>
    <a-card v-if="task_type!='look'" class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
    </a-card>
    <a-card :bordered="false">
      <a-form ref='ruleForm' :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="任务标题" name='name' required>
          <a-input type="text" maxlength="30" v-model:value="form.name" style="width:400px" placeholder="请输入任务标题" :suffix="form.name.length+'/30'"></a-input>
        </a-form-item>
        <a-form-item label="任务规则" required name='rule'>
          <quill v-model:value="form.rule" :showImg="true" :content="form.rule?JSON.parse(JSON.stringify(form.rule)):''" :height="600" />
        </a-form-item>
        <a-form-item label="申请材料" name='is_apply_describe'>
          <!-- <a-checkbox-group v-model:value="form.store_auth" @change='handelechange'> -->
          <a-checkbox v-model:checked="form.is_apply_describe" v-model:value="form.is_apply_describe">申请描述</a-checkbox>
          <a-checkbox v-model:checked="form.is_apply_image" v-model:value="form.is_apply_image" @change='handelechange'>申请图片</a-checkbox>
          <a-checkbox v-model:checked="form.is_apply_qrcode" v-model:value="form.is_apply_qrcode">申请二维码</a-checkbox>
          <a-tooltip placement='right'>
            <template #title>
              <p>申请材料，渠道在进行申请时需要提交的证明材料，至少选择一项</p>

              1.申请描述：在提交申请时，需要填写相关文字描述

              2.申请图片：在提交申请时，需要上传相关图片

              3.申请二维码：在提交申请时，需要根据申请的商品录入二维码
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
          <!-- </a-checkbox-group> -->
        </a-form-item>
        <a-form-item label="示例图片" name="apply_image_text" v-if="form.is_apply_image">
          <material :groupType='1' :imageList="form.apply_image_text" :max="3" v-on:handlechoose="(data)=>{
                      form.apply_image_text=form.apply_image_text.concat(data)}" v-on:handledel="(data)=>{form.apply_image_text=data}" />
          <!-- <material :groupType='1' :imageList="form.apply_image_text" :max="6" v-on:handlechoose="(data)=>{form.apply_image_text=data}" v-on:handledel="(data)=>{form.apply_image_text=data}" /> -->
        </a-form-item>
        <a-form-item v-if="task_type!='look'" label="状态" name='status' class="m-t-20" ref="status">
          <a-radio-group v-model:value="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="$route.query.type != 'look'&&task_type!='look'" :label-col="{ span: 0 }" :wrapper-col="{ span: 24,offset:3 }">
          <a-button type="primary" @click="submit">保存</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
import { profitAdd, profitEdit, profitDetail } from "@/api/assets";
import { LeftOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { reactive, toRefs, ref, onMounted, inject } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import store from "@/store";
import { addgrouptask, updategrouptask, getgrouptaskDetail } from "@/api/guide";
const formData = {
  name: "",
  rule: "",
  status: 0,
  is_apply_describe: 0,
  is_apply_image: 0,
  apply_image_text: [],
  is_apply_qrcode: 0,
};
export default {
  components: {
    LeftOutlined,
    QuestionCircleOutlined,
  },
  props: {
    task_id: {
      type: String || Number,
    },
    task_type: {
      type: String || Number,
    },
  },
  setup(props) {
    console.log(props);
    const $route = inject("$route");
    const $router = inject("$router");
    const form = ref({ ...formData });
    const ruleForm = ref();
    const state = reactive({
      isShowImg: false,
      info: store.state.user.info,
      monthGoods: {}, //月份商品
      listLoading: false,
      list: [],
      showGift: false,
      rules: {
        name: [{ required: true, message: "请输入任务标题！" }],
        rule: [{ required: true, message: "请输入任务规则" }],
        // is_apply_describe: [
        //   {
        //     required: true,
        //     message: "请输入任务规则" ,
        //     validator: async () => {
        //       if (form.value.is_apply_describe == 0||form.value.is_apply_image == 0||form.value.is_apply_qrcode==0) {
        //         return Promise.reject("申请材料至少选择一项");
        //       } else {
        //         return Promise.resolve();
        //       }
        //     },
        //   },
        // ],
      },
    });
    const methods = {
      submit() {
        ruleForm.value
          .validate()
          .then(async (res) => {
            const hide = message.loading("正在加载中...", 0);
            form.value.is_apply_describe = form.value.is_apply_describe ? 1 : 0;
            form.value.is_apply_image = form.value.is_apply_image ? 1 : 0;
            form.value.is_apply_qrcode = form.value.is_apply_qrcode ? 1 : 0;
            let result;
            if ($route.query.type == "add") {
              result = await addgrouptask({ ...form.value }).then(
                (res) => res.data
              );
            } else {
              result = await updategrouptask({ ...form.value }).then(
                (res) => res.data
              );
            }
            setTimeout(hide);
            if (iscode(result)) {
              message.success(result.message);
              setTimeout(() => {
                $router.go(-1);
              }, 1000);
            } else {
              message.error(result.message);
            }
          })
          .catch((error) => {
            message.error("请完善表单！");
          });
      },
      async setGift_data() {
        if ($route.query.type == "edit" || $route.query.type == "look") {
          const hide = message.loading("正在加载中...", 0);
          let result = await getgrouptaskDetail({ id: $route.query.id }).then(
            (res) => res.data
          );
          if (iscode(result)) {
            form.value = result.data;
          } else {
            message.error(result.msg);
          }
          setTimeout(hide);
        } else if (props.task_id) {
          const hide = message.loading("正在加载中...", 0);
          let result = await getgrouptaskDetail({ id: props.task_id }).then(
            (res) => res.data
          );
          if (iscode(result)) {
            form.value = result.data;
          } else {
            message.error(result.msg);
          }
          setTimeout(hide);
        }
      },
      handelechange(e) {
        e.target.checked
          ? (form.value.is_apply_image = 1)
          : (form.value.is_apply_image = 0);
        console.log(form.value.is_apply_image);
      },
    };
    onMounted(() => {
      methods.setGift_data();
    });
    return {
      form,
      ...toRefs(state),
      ...methods,
      ruleForm,
    };
  },
};
</script>
<style lang="less" scoped>
.tips {
  position: absolute;
  bottom: -15px;
  color: #999;
}
</style>
